<template>
    <van-popup v-model="show" class="livingSharePop">
        <div class="sharePopup">
            <van-icon name="cross" @click="iKnow" class="close"/>
            <div class="imgBox flex-end">
                <img :src="require('@/common/images/mliveimgs/img-share1.png')" alt="">
            </div>
            <p class="textTips">点击右上角···发送给微信好友或朋友圈</p>
            <div class="flex-center">
                <img class="img" :src="require('@/common/images/mliveimgs/img-share2.png')" alt="">
                <img class="img"  :src="require('@/common/images/mliveimgs/img-share3.png')" alt="">
            </div>
        </div>
    </van-popup>
</template>
<script>
  export default {
    name: 'livingSharePop',
    data() {
      return {
        show: false
      }
    },
    methods: {
      iKnow() {
        this.show = false
      },
      open() {
        this.show = true
      }
    }
  }
</script>
<style lang="scss">
    .livingSharePop{
        background: transparent;
        top: 22%;
        width: 100%;
        .close{
            position: absolute;
            top: 0.3rem;
            left: 0.32rem;
            width: 0.36rem;
            height: 0.36rem;
            color: #fff;
            font-size: 0.36rem;
        }
        .sharePopup{
            .imgBox{
                text-align: right;
                margin-right: 1.07rem;
                img{
                    width: 3.14rem;
                    height: 2.86rem;
                }
            }
            .textTips{
                text-align: center;
                font-size: 0.3rem;
                margin-bottom: 0.4rem;
                margin-top: 0.5rem;
                color: #fff;
                font-weight: 500;
            }
        }
        .img{
            width: 1.2rem;
            height: 1.2rem;
        }
        .img+.img{
            margin-left: 0.98rem;
        }
    }
</style>